import { UseQueryResult, useQuery } from 'react-query'
import { request } from '../request'

type User = {
  id: string
  role_id: number
  role_name: string
}

export const useGetUserRole = (): UseQueryResult<{ data: User }, Error> => {
  return useQuery<{ data: User }, Error>(
    ['currentUserRole'],
    () =>
      request({
        url: '/auth/user/role',
        method: 'GET',
      }),
    {
      retry: 0,
    },
  )
}
